/**
 * Store user data after successful login.
 *
 * @param state
 * @param payload
 */
export function SET_USER(state, payload) {
  state.user = payload;
}

/**
 * Clear all the content of the authenticated user.
 * (on logout)
 *
 * @param state
 */
export function CLEAR(state) {
  state.user = {};
}